import { queryClientOptions, userService } from '@libs/data-access/queries'
import { Alert } from '@libs/ui/ds'
import { GUIDE_URL } from '@libs/utils/environments'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import React from 'react'
import type { FC } from 'react'

const LockedAlert: FC = () => {
  const { t } = usePlanningFormTranslation()

  const currentUser = userService.user.useFetchCurrentUser(
    {
      queryParams: {
        with_permissions: false
      }
    },
    { staleTime: queryClientOptions.time.STATIC }
  )
  const languageOfUser = currentUser.data?.locale.toLowerCase()

  return (
    <div className='mb-4'>
      <Alert intent='semantic.orange'>
        <div>
          {t('component.locked.title')}
          <a
            href={`${GUIDE_URL}${languageOfUser}/articles/1205688`}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('component.locked.link')}
          </a>
        </div>
      </Alert>
    </div>
  )
}

export default LockedAlert
